//src/Components/Admin/SettingsSocialMedia.js

import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';

const ORANGE_COLOR = '#FF9900';
const DARK_BLUE = '#00008B';
const LIGHT_BLUE_BG = '#E3F2FD';

const getIconUrl = (platform) => {
  switch (platform.toLowerCase()) {
    case 'facebook':
      return 'https://img.icons8.com/color/48/000000/facebook-new.png';
    case 'instagram':
      return 'https://img.icons8.com/color/48/000000/instagram-new.png';
    case 'linkedin':
      return 'https://img.icons8.com/color/48/000000/linkedin.png';
    case 'youtube':
      return 'https://img.icons8.com/color/48/000000/youtube-play.png';
    case 'x':
      return 'https://img.icons8.com/?size=48&id=ClbD5JTFM7FA&format=png';
    default:
      return '';
  }
};

export default function SettingsSocialMedia({ socialLinks, setSocialLinks }) {
  const handleLinkChange = (index, value) => {
    const updated = [...socialLinks];
    // Deep clone the targeted object to prevent mutating the original state references
    updated[index] = { ...updated[index], url: value };
    setSocialLinks(updated);
  };

  return (
    <>
      <Typography sx={{ color: '#000000', fontWeight: 'normal', mb: 0.5 }}>
        Social Media Links
      </Typography>
      <TableContainer sx={{ mt: 1 }}>
        <Table size='small' sx={{ '& td, & th': { border: 0, py: 0.25, px: 1 } }}>
          <TableBody>
            {socialLinks.map((link, index) => {
              const iconUrl = getIconUrl(link.platform);
              return (
                <TableRow key={link.platform}>
                  <TableCell sx={{ width: '40%', verticalAlign: 'middle', pt: 1 }}>
                    <Typography
                      sx={{
                        color: '#000000',
                        fontWeight: 'normal',
                        fontSize: '0.85rem',
                      }}>
                      {link.platform} URL
                    </Typography>
                  </TableCell>
                  <TableCell colSpan={2}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                      {iconUrl && (
                        <Box
                          component='img'
                          src={iconUrl}
                          alt={link.platform}
                          sx={{ width: 29, height: 29, display: 'block', flexShrink: 0 }}
                        />
                      )}
                      <TextField
                        fullWidth
                        placeholder={`https://www.${link.platform.toLowerCase()}.com/...`}
                        value={link.url}
                        onChange={(e) => handleLinkChange(index, e.target.value)}
                        variant='standard'
                        size='small'
                        InputProps={{
                          disableUnderline: true,
                          style: {
                            fontSize: '0.8rem',
                            fontWeight: 'normal',
                            color: DARK_BLUE,
                          },
                        }}
                        sx={{
                          backgroundColor: LIGHT_BLUE_BG,
                          px: 1,
                          py: 0.5,
                          borderRadius: 1,
                          border: `1px solid ${ORANGE_COLOR}`,
                          '& .MuiInputBase-input': {
                            color: DARK_BLUE,
                            fontWeight: 'normal',
                          },
                          '&:hover': { backgroundColor: LIGHT_BLUE_BG },
                          '&:focus-within': { backgroundColor: LIGHT_BLUE_BG },
                        }}
                      />
                    </Box>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
